/**
 * 禁止卡牛页面下拉刷新方法
 * 卡牛IOS 版本 7.7.4 - 7.8.1 版本才设置是否可以下拉刷新
 * 说明：7.8.1版本以后（不包含7.8.1）理财容器已经禁止下拉刷新
 */

import useragent from '@common/useragent'
import { compare } from './version'
import clientBridge from '@common/client/src/bridge'

export default (type = false) => {
  if (useragent.isKaniu && useragent.isIOS) {
    // 获取卡牛IOS版本号
    clientBridge.call('cardniu://api/getUserInfo', 'onGetUserInfo', (dataInfo) => {
      if (dataInfo && dataInfo.version) {
        const knVersion = dataInfo.version
        const frontVersion = '7.7.4'
        const laterVersion = '7.8.1'
        if (compare(frontVersion, knVersion) && !compare(laterVersion, knVersion)) {
          if (type) {
            clientBridge.call('cardniu://app/webview/config?isCanPullRefresh=true')
          } else {
            clientBridge.call('cardniu://app/webview/config?isCanPullRefresh=false')
          }
        }
      }
    })
  }
}


// WEBPACK FOOTER //
// ./node_modules/@common/client/src/isCanPullRefresh.js